<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="8" class="text-justify">
        <h2 class="display-2 text-center mb-4 text-secondary">How You Can Contribute</h2>

        <p class="text-body-1">
          The Holonet Galactic Encyclopedia is an open, community-driven project. There are many ways you can help make
          this resource even better, and we welcome contributions of all kinds!
        </p>

        <h3 class="mt-5 text-secondary">1. Add Information to Wikidata</h3>
        <p class="text-body-1">
          One of the best ways to contribute is by helping expand the Star Wars knowledge base on Wikidata. Wikidata is
          a free, open knowledge base that anyone can edit. By adding new data, references, and details about the Star
          Wars galaxy, you help make this project more complete and accessible for everyone.
          If you're interested in contributing, we recommend joining the <a
            href="https://m.wikidata.org/wiki/Wikidata:WikiProject_Star_Wars" target="_blank">Wikidata: WikiProject Star
            Wars</a>, where you can find resources, guidelines, and a community of like-minded individuals working to
          improve Star Wars-related data on Wikidata.
        </p>

        <h3 class="mt-5 text-secondary">2. Add Information to Wookieepedia</h3>
        <p class="text-body-1">
          Additionally, you can contribute to Wookieepedia, the Star Wars wiki, by enriching articles, providing
          sources, and ensuring the accuracy of lore.
          Your efforts in Wookieepedia help provide fans worldwide with a comprehensive and reliable Star Wars resource.
          Visit <a href="https://starwars.fandom.com/wiki/Main_Page" target="_blank">Wookieepedia</a> to get started.
        </p>

        <h3 class="mt-5 text-secondary">3. Support the Project</h3>
        <p class="text-body-1">
          If you enjoy using the site and would like to help keep the project running, consider making a small donation.
          Your contribution helps cover the costs of maintaining the website and servers, and also shows appreciation
          for the time and effort volunteers have spent developing it.
          Part of your donation will also go towards supporting Wikimedia, the platform that powers Wikidata, to help
          sustain the free knowledge initiative.
        </p>
        <v-col cols="12" md="12" class="text-center">
          <v-btn color="secondary" large href="https://buymeacoffee.com/metafire18" target="_blank" class="mt-4">
            Donate to Support the Project
          </v-btn>
        </v-col>
        <!-- Cite this work -->
        <h3 class="mt-5 text-secondary">4. Cite this work</h3>
        <p class="text-body-1">
          Yoan Chabot (2025). Holonet Galactic Encyclopedia. Retrieved from https://sw-holonet.com/
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { useHead } from '@unhead/vue';

export default {
  name: 'About',
  setup() {
    useHead({
      title: "Contribute to Holonet – Expand Star Wars Knowledge on Wikidata & Wookieepedia",
      meta: [
        {
          name: "description",
          content: "Contribute to the Holonet Galactic Encyclopedia by adding and improving Star Wars data on Wikidata and Wookieepedia. Learn how to help grow this open knowledge project and support the community!",
        },
        {
          property: "og:title",
          content: "Contribute to Holonet – Expand Star Wars Knowledge on Wikidata & Wookieepedia",
        },
        {
          property: "og:description",
          content: "Join the Holonet project by contributing to Wikidata and Wookieepedia. Help expand and refine Star Wars data for fans and researchers worldwide.",
        },
        {
          property: "og:url",
          content: "https://sw-holonet.com/contribute",
        },
        { property: "og:type", content: "website" },
        {
          name: "twitter:title",
          content: "Contribute to Holonet – Expand Star Wars Knowledge on Wikidata & Wookieepedia",
        },
        {
          name: "twitter:description",
          content: "Support the Holonet Galactic Encyclopedia by contributing to Wikidata and Wookieepedia. Help build the ultimate Star Wars knowledge base.",
        },
        { name: "twitter:card", content: "summary" },
        {
          name: "keywords",
          content: "contribute to Holonet, Star Wars Wikidata, Wookieepedia contributions, Star Wars data, open knowledge project, Star Wars community, Holonet contributions",
        },
      ],
    });
    }
};
</script>
